import { render, staticRenderFns } from "./RealtimeApp.vue?vue&type=template&id=160d6ae3&scoped=true"
import script from "./RealtimeApp.vue?vue&type=script&lang=js"
export * from "./RealtimeApp.vue?vue&type=script&lang=js"
import style0 from "./RealtimeApp.vue?vue&type=style&index=0&id=160d6ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160d6ae3",
  null
  
)

export default component.exports